import { render, staticRenderFns } from "./FiltersAdd.vue?vue&type=template&id=6f96a881&scoped=true&"
import script from "./FiltersAdd.vue?vue&type=script&lang=js&"
export * from "./FiltersAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f96a881",
  null
  
)

export default component.exports